import card01 from '../asset/card01.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';

const data = [
  {
    listTitle: '优秀应用案例',
    listSubTitle: '',
    cards: [
      // {
      //   imgUrl: card01,
      //   title: "alpaca",
      //   url: 'https://www.getalpaca.io/',
      //   summary: "Exciting photoshop implementation"
      // },
      {
        imgUrl: card01,
        title: "Stablender",
        url: "https://github.com/shellward/StablenderDiffusion",
        summary: "a WIP blender plugin with SD"
      },
    ]
  },
];

export default function CardList() {
  return (
    <Container fluid="md">
    {data.map((d, idx) => (
      <div key={idx}>
        <div className="projects-header">
          <h2>{d.listTitle}</h2>
          <p>{d.listSubTitle}</p>
        </div>
        <Row>
          {d.cards.map((card, jdx) => (
          <Col sm={6} md={4} lg={3} key={jdx}>
            <Card style={{marginBottom: '20px'}}>
              <Card.Img variant="top" src={card.imgUrl} />
              <Card.Body>
                <Card.Title>{card.title}</Card.Title>
                <Card.Text>{card.summary}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          ))}
          <Col sm={6} md={4} lg={3}>
           <p>(待补充……)</p>
          </Col>
        </Row>
      </div>
    ))}
    </Container>
  )
}
